import React, { useEffect, useState } from "react";

// gsap
import gsap from "gsap";

const words = [
  "Creative",
  "Enthusiast",
  "Developer",
  "Dreamer",
  "Designer",
  "Laughter",
  "Blogger",
  "Me",
];

const Overlay = () => {
  const [word, setWord] = useState(words[0]);

  useEffect(() => {
    let count = 0;

    const width = window.screen.width;

    setTimeout(() => {
      let interval = setInterval(function () {
        setWord(words[count]);

        count++;
        if (count === 8) {
          clearInterval(interval);

          const tl = gsap.timeline();
          tl.to(".text", {
            duration: 1.6,
            y: -250,
            skewY: -20,
            ease: "expo.inOut",
            delay: 0.2,
          })
            .to(".title", {
              duration: 0,
              delay: width <= 768 ? -1 : 0,
              opacity: 1,
            })
            .to(".intro-subtitle", {
              duration: 0,
              delay: width <= 768 ? -1 : 0,
              opacity: 1,
            })
            .to(".overlay", {
              duration: 1.8,
              width: 0,
              ease: "expo.inOut",
              delay: -0.8,
            })
            .from(".title", {
              duration: width <= 768 ? 0 : 1,
              ease: "power4.ease",
              y: width <= 768 ? 0 : 250,
              delay: -1,
            })
            .from(".intro-subtitle", {
              duration: width <= 768 ? 0 : 1.8,
              ease: "power4.ease",
              y: width <= 768 ? 0 : 400,
              delay: -1.4,
            })
            .to(".home", {
              duration: 0,
              height: "max-content",
            });
        }
      }, 250);
    }, 250);
  }, []);

  return (
    <div className="overlay">
      <div className="container-fluid center">
        <div className="wrapper center">
          <div className="text">{`.${word}`}</div>
        </div>
      </div>
    </div>
  );
};

export default Overlay;
